"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ButtonFooter = void 0;
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styles = require("@mui/material/styles");
var _KansaAnswerConsts = require("../../common/consts/KansaAnswerConsts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 監査回答登録画面フッタのボタン
 */
const StyledFooter = (0, _styles.styled)('footer')({
  width: '100%',
  textAlign: 'right'
});
const StyledFooterButton = (0, _styles.styled)(_CButton.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    marginLeft: theme.spacing(2)
  };
});
const ButtonFooter = props => {
  const {
    intl,
    returnBtn,
    gyomuCd,
    btnClick,
    kansaAnsStsCd
  } = props;
  return /*#__PURE__*/_react.default.createElement(StyledFooter, null, returnBtn(), _CodeConsts.CODE.KANSA_ANS_STS.CODE_3 !== kansaAnsStsCd && /*#__PURE__*/_react.default.createElement(StyledFooterButton, {
    submit: true,
    onClick: () => {
      btnClick(_KansaAnswerConsts.CONSTS.ANS_BTN.ANSWER_TEMP);
    }
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_ANSWERED_TEMPORARILY_STORE
  })), gyomuCd === _CodeConsts.CODE.KANSA_GYOMU_CD.CODE_1 ? /*#__PURE__*/_react.default.createElement(StyledFooterButton, {
    submit: true,
    onClick: () => {
      btnClick(_KansaAnswerConsts.CONSTS.ANS_BTN.ANSWER_STORE);
    }
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_ANSWER_STORE
  })) : /*#__PURE__*/_react.default.createElement(StyledFooterButton, {
    submit: true,
    onClick: () => {
      btnClick(_KansaAnswerConsts.CONSTS.ANS_BTN.ANSWER_HIKANSA);
    }
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_HI_KANSA_BUMON_STORE
  })));
};
exports.ButtonFooter = ButtonFooter;
var _default = exports.default = (0, _reactIntl.injectIntl)(ButtonFooter);